module.exports = __webpack_public_path__ + "static/media/blogs-empty.61d2f8fd.svg";